var _path, _path2, _stop, _stop2, _stop3, _stop4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastWarningV2 = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "toast-warning-v2_svg__a)",
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#" + _uid + "toast-warning-v2_svg__b)",
    strokeWidth: 0.5,
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.25 9.75h1.5v6h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C27803",
    d: "m17.829 15.462-4.685-8.2A1.33 1.33 0 0 0 12 6.601a1.32 1.32 0 0 0-1.143.66l-4.685 8.2a1.28 1.28 0 0 0 0 1.281 1.31 1.31 0 0 0 1.144.659h9.369a1.3 1.3 0 0 0 1.143-.659 1.28 1.28 0 0 0 0-1.28m-6.257-4.54a.427.427 0 1 1 .857 0v2.16a.434.434 0 0 1-.429.431.427.427 0 0 1-.428-.431zM12 15.674a.64.64 0 0 1-.594-.4.65.65 0 0 1 .14-.707.642.642 0 0 1 1.097.458.65.65 0 0 1-.188.459.64.64 0 0 1-.455.19"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-warning-v2_svg__a",
    x1: -0.951,
    x2: 12,
    y1: -24.333,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27803"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3C"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-warning-v2_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F69"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })))));
};
export { SvgToastWarningV2 as ReactComponent };
export default __webpack_public_path__ + "d19ab62bca5c2495dc9c822a92059b0f.svg";